import React, { memo } from "react";
import { Button } from "antd";
import { CSSTransition } from "react-transition-group";
import "./RoleCallout.scss";

type Props = {
  onOK: () => void;
  onViewDetailsClick: () => void;
  show: boolean;
};

function RoleCallout({ onOK, onViewDetailsClick, show }: Props) {
  const handleViewDetailsClick = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    e.preventDefault();
    onViewDetailsClick();
  };
  return (
    <CSSTransition appear in={show} timeout={750} classNames="role-callout-anime" unmountOnExit>
      <dialog open className="role-callout">
        <div className="role-callout-content">
          <h3 className="title title-anim">Your role has limited data access</h3>
          <p className="desc title-anim">You are viewing pre-filtered data</p>
          <Button className="gotit-button" type="default" onClick={onOK}>
            Got it
          </Button>
          <a href="" className="view-details-anchor" onClick={handleViewDetailsClick}>
            View Details
          </a>
        </div>
      </dialog>
    </CSSTransition>
  );
}

export default memo(RoleCallout);
